module.exports = __webpack_public_path__ + "static/media/07AFCjianxiugong2.efe660db.png";